import * as o from "react";
import n from "../lib/IconBase.es.js";
import c from "../defs/ClockAfternoon.es.js";
const e = o.forwardRef((r, t) => /* @__PURE__ */ o.createElement(n, { ref: t, ...r, weights: c }));
e.displayName = "ClockAfternoonIcon";
const m = e;
export {
  m as ClockAfternoon,
  e as ClockAfternoonIcon
};
